import { render } from "./Gamepass.vue?vue&type=template&id=6bf82287&scoped=true&ts=true"
import script from "./Gamepass.vue?vue&type=script&lang=ts"
export * from "./Gamepass.vue?vue&type=script&lang=ts"

import "./Gamepass.vue?vue&type=style&index=0&id=6bf82287&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf82287"]])

export default __exports__